import { jsx } from 'panel';
import { InputEl } from 'common/components/input';
import { CopyToClipboardButtonEl } from './copy-to-clipboard-button';
export function template() {
  return jsx("div", {
    sel: '.mp-copy-to-clipboard'
  }, jsx(InputEl, {
    sel: '.copy-input',
    attrs: {
      readonly: true,
      type: "text",
      label: this.attr("label")
    },
    props: {
      value: this.attr("value")
    },
    hook: {
      insert: _ref => {
        let {
          elm
        } = _ref;
        return this.helpers.handleInsert(elm);
      }
    }
  }), jsx(CopyToClipboardButtonEl, {
    sel: '.copy-button',
    attrs: {
      value: this.attr("value")
    }
  }, "Copy"));
}